import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Field, ErrorMessage, useFormikContext } from "formik";
import VariantInterface from "../../Interfaces/VariantInterface";
import { useState } from "react";
import Color from "./Color";

interface ColorsInterface {
    name: string,
    options: VariantInterface[],
    onChange: (e: Event) => void
}

const Colors = ({name, options, onChange}:ColorsInterface) => {
    const context = useFormikContext<any>();
    const trueName = `${name}.variantId`;
    const [maskImageClass, setMaskImageClass] = useState<string>('swiper-mask-beginning');

    const updateGradientMask = (swiper: any) => {
        const allSlidesShowing = swiper.slides.every((slide: any) => slide.classList.contains('swiper-slide-fully-visible'));
        if (allSlidesShowing) return;
        if(swiper.isBeginning) {
            setMaskImageClass('swiper-mask-beginning');
            return;
        }
        if(swiper.isEnd) {
            setMaskImageClass('swiper-mask-end');
            return;
        }
        setMaskImageClass('swiper-mask');
    }
    const updateGradientMaskEnd = (swiper: any) => {
        const allSlidesShowing = swiper.slides.every((slide: any) => slide.classList.contains('swiper-slide-fully-visible'));
        if (allSlidesShowing) return;
        setMaskImageClass('swiper-mask-end');
    }

    return (
        <div className={`material-tiles`}>
            <Swiper
                onSlideChange={(e) => updateGradientMask(e)}
                onReachEnd={(e) => updateGradientMaskEnd(e)}
                modules={[Navigation]}
                navigation={{
                    prevEl: '.swiper-button-prev',
                    nextEl: '.swiper-button-next'
                }}
                //@ts-ignore
                spaceBetween={10}
                watchSlidesProgress={true}
                keyboard={true}
                slidesPerView={'auto'}
            >
                {options?.map((variant, index) => (
                    <SwiperSlide key={index}>
                        <Color
                            variant={variant}
                            index={index}
                            name={trueName}
                            checked={context.values[name]?.variantId == variant.id}
                            onChange={onChange}
                            />
                    </SwiperSlide>
                ))}
                <div className="swiper-button swiper-button-prev"></div>
                <div className="swiper-button swiper-button-next"></div>
                <div className={`absolute mask ${maskImageClass}`}></div>
            </Swiper>
            <ErrorMessage name={trueName} component={"div"} className={"configurator-content__error rte links-underline"} />
        </div>
    );
}

export default Colors;